import React from 'react'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import { useValue } from '@morningtrain/react-resources'
import WhenCanAdjustInventoryOrder from 'pages/app/inventory/order/partials/WhenCanAdjustInventoryOrder'
import { Translation } from '@morningtrain/react-translations'
import { useEnvValue } from '@morningtrain/react-helpers'
import ProductOrderInfo from "ui/elements/ProductOrderInfo";

export default function DraftOrderColumns ({ excludeWithoutNorm = false }) {
  const itemId = useValue('id')
  const [norm] = useEnvValue(['globals.inventory.order_items', itemId, 'norm'].join('.'))
  const [errorDeliveryDate] = useEnvValue(['globals.inventory.order_items', itemId, 'error_delivery_date'].join('.'), false)
  let [filterByString] = useEnvValue('globals.inventory.filter_order_by_string', '')
  let name = useValue('name')
  let sku = useValue('sku')
  let max_order_qty = useValue('max_order_quantity')
  let soldOut = Number.isInteger(max_order_qty) && max_order_qty < 1

  filterByString = filterByString.trim().toLowerCase()
  let isFilterPassed = filterByString.length < 1

  if (!isFilterPassed) {
    isFilterPassed = (name && name.toLowerCase().includes(filterByString)) || (sku && sku.includes(filterByString))
  }

  if (isFilterPassed == null) {
    isFilterPassed = true
  }

  let totalDisplay = function() {
    if (soldOut) {
      return <span className='text-sm text-red-500 leading-5'>
        <Translation name='inventory.order.columns.sold_out'/>
      </span>
    }

    if (errorDeliveryDate) {
      return <span className='text-sm text-red-500 leading-5 whitespace-normal'>
        <Translation name='errors.order.no_delivery_date'/>
      </span>
    }

    return <Displays.InventoryItemTotal inventoryItemId={itemId} twoLines/>

  }

  let cantOrder = soldOut || errorDeliveryDate;

  return (
    <>
      {(((excludeWithoutNorm && norm === 0) || !isFilterPassed)) ? null : (
        <>
          <Columns.Column className='w-full'>
            <ProductOrderInfo
              image={<Displays.Image name='image' className='max-h-full' />}
              title={<Displays.Text name='name' />}
              textRow1={(<> <Translation name='inventory.order.item.sku'/> <Displays.Text name='sku' /></>)}
              textRow2={(<>
                <Translation name='inventory.order.item.min_units'/> <Displays.Integer name='min_unit' /> <Displays.Text name='unit_type' /> |{' '}
                <Translation name='inventory.order.item.amount_units'/> <Displays.Text name='unit_type' />: <Displays.Integer name='amount_per_unit' />
              </>)}
              warningRow={errorDeliveryDate ? (<>
                <Translation name='errors.order.delivery_date_starting_from' data={{date: errorDeliveryDate}}/>
              </>) : null}
            />
          </Columns.Column>
          <WhenCanAdjustInventoryOrder>
            <Columns.Column
              alignment='center'
              label={<Translation name='inventory.columns.expected_usage' />}
              display={<Displays.InventoryItemNorm inventoryItemId={itemId} />}
              name='norm'
            />
          </WhenCanAdjustInventoryOrder>
          <Columns.Column
            alignment='center'
            label={<Translation name='inventory.columns.in_stock' />}
            display={<Displays.EditInventoryItemQuantity inventoryItemId={itemId} min={0} name='holdings' disabled={cantOrder} />}
            name='holdings'
          />
          <WhenCanAdjustInventoryOrder>
            <Columns.Column
              alignment='center'
              label={<Translation name='inventory.columns.suggested' />}
              display={<Displays.InventoryItemSuggestion inventoryItemId={itemId} />}
              name='suggestion'
            />
            <Columns.Column
              alignment='center'
              label={<Translation name='inventory.columns.deviation' />}
              display={<Displays.EditInventoryItemQuantity inventoryItemId={itemId} name='adjustment' disabled={cantOrder} />}
              name='adjustment'
            />
            <Columns.Column className='max-w-sm'
              alignment='center'
              label={<Translation name='inventory.columns.order_total' />}
              display={totalDisplay}
            />
          </WhenCanAdjustInventoryOrder>
        </>
      )}
    </>
  )
}
